import { Brain, ShieldCheck, Blocks, Route, Heart } from "lucide-react";

const qualities = [
  { icon: Brain, title: "Critical thinker", body: "Questions before it builds." },
  { icon: ShieldCheck, title: "Spotlights risks", body: "Finds what others miss." },
  { icon: Blocks, title: "Focuses on architecture", body: "Builds for scale, not just speed." },
  { icon: Route, title: "Keeps you on track", body: "Helps you stay in the right lane." },
  { icon: Heart, title: "Quietly supportive", body: "Tough on bad ideas. Kind to good ones." },
];

export function WhyBootRise() {
  return (
    <section className="bg-cream py-20 sm:py-28" data-testid="why-bootrise">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-brand">Lint&apos;s core qualities</p>
          <h2 className="font-display mt-3 text-3xl font-semibold tracking-tight text-navy sm:text-5xl">
            Not just a tool.
            <br />
            <span className="italic text-ink-muted">A better way to build.</span>
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-ink-muted sm:text-lg">
            Your AI can write the code. Lint helps you understand the
            consequences, and answers the one question that keeps founders up:{" "}
            <span className="font-medium text-navy">Am I ready to release?</span>
          </p>
        </div>
        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {qualities.map(({ icon: Icon, title, body }, i) => (
            <li
              key={title}
              className="rounded-3xl border border-border bg-surface-elevated p-5 transition-transform duration-300 hover:-translate-y-1"
              data-testid={`lint-quality-${i}`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-sage-soft text-brand">
                <Icon size={20} strokeWidth={1.8} />
              </span>
              <h3 className="mt-4 text-base font-semibold text-navy">{title}</h3>
              <p className="mt-1 text-sm text-ink-muted">{body}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
